// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/draftContractIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Draft" aria-label="Draft" />;
}
